import {useCallback, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';

import {PinEntry} from '~/features/Auth/PinEntry';
import {useApi} from '~/modules/api';

import {useAuth} from '~/store/hooks';
import {authActions} from '~/store/slices';

export const VerifyPin = () => {
  const api = useApi();
  const dispatch = useDispatch();

  const {onSetShowPinConfirm, fetchUser} = useAuth();

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [pin, setPin] = useState('');

  const pinValid = pin.length === 6;

  const onChangePin = useCallback((pin: string) => {
    if (pin.length === 6) {
      setPin(pin);
    }
  }, []);

  const verifyPin = useCallback(
    async (pin: string) => {
      setSubmitting(true);
      try {
        const resp = await api.fetch({
          url: '/auth/verifyPin',
          method: 'POST',
          data: {pinCode: pin},
        });
        if (resp.status === 200) {
          await fetchUser();
          
          // Update last pin verification timestamp
          dispatch(authActions.setLastPinVerification());
        }
        onSetShowPinConfirm({showPinConfirm: false});
      } catch (err) {
        if (err instanceof Error) {
          setError(err.message);
        }
      }
      setSubmitting(false);
    },
    [api, onSetShowPinConfirm, fetchUser, dispatch],
  );

  useEffect(() => {
    if (pinValid) {
      verifyPin(pin);
    }
  }, [pin, pinValid, verifyPin]);

  return (
    <div className="flex flex-col items-center">
      <h3 className="text-subtitlelarge mb-4">Confirm your pin code</h3>

      <div className="mb-4">
        <PinEntry onChangePin={onChangePin} />
      </div>

      {submitting && <span className="loading loading-dots loading-md"></span>}

      {!!error && (
        <div role="alert" className="alert alert-error">
          <span className="text-center">{error}</span>
        </div>
      )}
    </div>
  );
};
